import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e3df4ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "toast-popup position-fixed bottom-0 end-5 end-md-5 p-3 m-md-3 text-center"
}
const _hoisted_2 = {
  class: "toast bg-light",
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true",
  "data-bs-autohide": "false",
  ref: "signToastRef"
}
const _hoisted_3 = { class: "toast-header bg-gray text-white" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close ms-auto text-white",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1))
const _hoisted_5 = { class: "toast-body bg-gray" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle-fill me-1 text-warning" }, null, -1))
const _hoisted_7 = {
  class: "toast bg-light",
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true",
  "data-bs-autohide": "false",
  ref: "toastRef"
}
const _hoisted_8 = { class: "toast-header bg-gray text-white" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close ms-auto text-white",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1))
const _hoisted_10 = { class: "toast-body bg-gray" }
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = { class: "transaction-hash me-2" }
const _hoisted_13 = {
  key: 0,
  class: "bi bi-check-circle-fill text-success ms-1"
}
const _hoisted_14 = {
  key: 1,
  class: "bi bi-x-circle-fill text-danger ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!

  return (Object.keys($setup.transactions).length || $setup.signTransactionToast)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("toast.sign")), 1),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("toast.signMessage")), 1)
          ])
        ], 512),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("toast.transactions")), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.transactions).reverse(), (hash) => {
              return (_openBlock(), _createElementBlock("div", {
                key: hash,
                class: "transaction-item mb-2"
              }, [
                _createElementVNode("a", {
                  href: $data.EXPLORER_URL + hash,
                  target: "_blank",
                  class: "text-white text-decoration-none d-flex align-items-center",
                  title: hash
                }, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString($setup.shortenHash(hash)), 1),
                  _createVNode(_component_Loader, {
                    loading: null === $setup.transactions[hash]
                  }, null, 8, ["loading"]),
                  (true === $setup.transactions[hash])
                    ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                    : (null !== $setup.transactions[hash])
                      ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                      : _createCommentVNode("", true)
                ], 8, _hoisted_11)
              ]))
            }), 128))
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}